import $ from 'jquery';

(function(){
  function toggleDropdown(event){
    event.preventDefault();
    const $element = $(this);
    const $dropdown = $element.next();
    const $navbarParents = $('.navbar-nav .dropdown');
    const $elements = $('.navbar .dropdown-toggle')

    event.preventDefault();
    event.stopPropagation();
    $navbarParents.removeClass('open');

    const wasOpen = $element.hasClass('is-activeDropdown');

    $elements.each(function(idx, el){
      const $el = $(el);
      close($el, $el.next());
    })

    if (!wasOpen){
      open($element, $dropdown);
    }
  }

  function open(el, dropdown){
    el.addClass('is-activeDropdown');
    dropdown.show();
  }

  function close(el, dropdown){
    el.removeClass('is-activeDropdown');
    dropdown.hide();
  }

  $(document).ready(function(){
    $('.dropdown-toggle').click(toggleDropdown);
    $('.nav-dropdownMessages', '.nav-dropdownLarge').click(event => event.stopPropagation());
    $('html').click(function(event){
      $('.navbar .dropdown-toggle').each((idx, el) => {
        let $element = $(el);
        close($element, $element.next());
      });
    });
  });

})();
